import {
  SquaresFour, Sparkle, PencilSimple, Images, Palette, Stack, ListChecks, PlugsConnected, PaperPlaneTilt, Truck, FilmSlate, Strategy,
} from "@phosphor-icons/react";

// Creative Studio sitemap (RFC-0005 / SPRINT-102). Mirrors the Promotion Center
// navigation conventions — one first-party product under its own top-level route.
export const CREATIVE_NAV = [
  { to: "/creative", key: "dashboard", label: "Dashboard", Icon: SquaresFour, end: true },
  { to: "/creative/campaigns", key: "campaigns", label: "Campaigns", Icon: Strategy },
  { to: "/creative/generate", key: "generate", label: "Generate", Icon: Sparkle },
  { to: "/creative/video", key: "video", label: "Video Studio", Icon: FilmSlate },
  { to: "/creative/edit", key: "edit", label: "Edit", Icon: PencilSimple },
  { to: "/creative/assets", key: "assets", label: "Assets", Icon: Images, section: "library" },
  { to: "/creative/brand-kits", key: "brand-kits", label: "Brand Kits", Icon: Palette },
  { to: "/creative/templates", key: "templates", label: "Templates", Icon: Stack },
  { to: "/creative/publishing", key: "publishing", label: "Publishing", Icon: PaperPlaneTilt, section: "operations" },
  { to: "/creative/delivery", key: "delivery", label: "Delivery", Icon: Truck },
  { to: "/creative/jobs", key: "jobs", label: "Jobs", Icon: ListChecks },
  { to: "/creative/providers", key: "providers", label: "Marketplace", Icon: PlugsConnected },
];
